import { render } from "./FormShareOptions.vue?vue&type=template&id=5028e510&scoped=true"
import script from "./FormShareOptions.vue?vue&type=script&lang=js"
export * from "./FormShareOptions.vue?vue&type=script&lang=js"

import "./FormShareOptions.vue?vue&type=style&index=0&id=5028e510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5028e510"]])

export default __exports__